import { HStack, Text, type TextProps } from "@chakra-ui/react";
import { Icon } from "@src/components/ui-kit/Icon";
import type { IconNames } from "@src/utils/types/iconNames";
import type React from "react";
import type { FunctionComponent } from "react";

type SectionHeading = {
  children: React.ReactNode;
  iconName?: IconNames;
} & TextProps;

export const SectionHeading: FunctionComponent<SectionHeading> = ({
  children,
  iconName,
  ...props
}) => {
  return (
    <HStack>
      {iconName && <Icon color="grey.400" name={iconName} />}
      <Text color="grey.500" fontSize="xs" fontWeight="medium" {...props}>
        {children}
      </Text>
    </HStack>
  );
};
